import script from "./AboutEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutEdit.vue?vue&type=script&setup=true&lang=js"

import "./AboutEdit.vue?vue&type=style&index=0&id=cd9a230e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd9a230e"]])

export default __exports__